export default "/images/GoldAward.png?607f99d9f9dd284b1e57301f2ed0f2f6";